import get from 'lodash/get';

export default {
    props: {
        name: {type: String, required: true},
    },

    computed: {
        formParent() {
            if (this.name !== null) {
                let parent = this.$parent;
                while (parent) {
                    if (parent.$form instanceof Object) {
                        return parent;
                    }
                    parent = parent.$parent;
                }
            }
            return null;
        },

        $form() {
            return get(this.formParent.$form, this.name);
        },

        $v() {
            return get(this.formParent.$v, this.name);
        },
    },
};